import { useState } from "react";
import { MapPin } from "lucide-react";
import { toast } from "sonner";
import { api } from "../api";

const GEO_ERROR = "Konum bilgisi alınamadı. Lütfen cihazınızın konum iznini açın.";

export default function LocationButton({ onLocated, testid = "location-button", className = "" }) {
  const [busy, setBusy] = useState(false);
  const locate = () => {
    if (!navigator.geolocation) { toast.error(GEO_ERROR); return; }
    setBusy(true);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        try {
          const { data } = await api.post("/geo/reverse", { lat: pos.coords.latitude, lng: pos.coords.longitude });
          if (data && data.province) {
            onLocated({ city: data.province, district: data.district || "" });
            toast.success(`Konum algılandı: ${data.province}${data.district ? ` / ${data.district}` : ""}`);
          } else {
            toast.error(GEO_ERROR);
          }
        } catch {
          toast.error(GEO_ERROR);
        }
        setBusy(false);
      },
      () => { toast.error(GEO_ERROR); setBusy(false); },
      { timeout: 10000 }
    );
  };
  return (
    <button type="button" data-testid={testid} onClick={locate} disabled={busy}
      className={`flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-xl border border-cyan-400/40 text-cyan-300 text-sm font-semibold hover:bg-cyan-400/10 transition-colors disabled:opacity-50 ${className}`}>
      <MapPin className="w-4 h-4" /> {busy ? "Konum alınıyor..." : "Konumumu Kullan"}
    </button>
  );
}
